import { withSpacing } from '../../util/spacing.js';
import useScreenSize from '../../util/useScreenSize.js';
import { m, l } from '@drone-js/media-query';
import styled from 'styled-components';

var MIN_WIDTH = 320.0;
var MAX_WIDTH = 1100.0;
var getStyles = function getStyles(props) {
  var styles = {
    fontWeight: props.$fontWeight,
    letterSpacing: props.$letterSpacing,
    textDecoration: props.$textDecoration,
    textDecorationLine: props.$textDecorationLine,
    textDecorationStyle: props.$textDecorationStyle,
    textUnderlineOffset: props.$textUnderlineOffset,
    color: props.$textColor,
    fill: props.$textColor,
    textAlign: props.$textAlign,
    textTransform: props.$textTransform,
    display: props.$display
  };
  if (props.$lineClamp) {
    styles.display = '-webkit-box';
    styles.overflow = 'hidden';
    styles.textOverflow = 'ellipsis';
    styles.WebkitLineClamp = props.$lineClamp;
    styles.WebkitBoxOrient = 'vertical';
  }
  if (props.$responsive) {
    var _window, _window$supports;
    var _props$$responsive = props.$responsive,
      fontSize = _props$$responsive.fontSize,
      lineHeight = _props$$responsive.lineHeight;
    if ((_window = window) !== null && _window !== void 0 && (_window = _window.CSS) !== null && _window !== void 0 && (_window$supports = _window.supports) !== null && _window$supports !== void 0 && _window$supports.call(_window, 'font-size', 'clamp(1px, 1vw, 1px)')) {
      var fontSlope = (fontSize.max - fontSize.min) / (MAX_WIDTH - MIN_WIDTH);
      var fontIntersection = -MIN_WIDTH * fontSlope + fontSize.min;
      styles.fontSize = "clamp(".concat(fontSize.min, "px, ").concat(fontIntersection, "px + ").concat(fontSlope * 100, "vw, ").concat(fontSize.max, "px)");
      var lineSlope = (lineHeight.max - lineHeight.min) / (MAX_WIDTH - MIN_WIDTH);
      var lineIntersection = -MIN_WIDTH * lineSlope + lineHeight.min;
      styles.lineHeight = "clamp(".concat(lineHeight.min, "px, ").concat(lineIntersection, "px + ").concat(lineSlope * 100, "vw, ").concat(lineHeight.max, "px)");
    } else {
      styles.fontSize = "".concat(fontSize.min, "px");
      styles.lineHeight = "".concat(lineHeight.min, "px");
      styles["@media ".concat(m.get(false))] = {
        fontSize: "".concat(fontSize.min + (fontSize.max - fontSize.min) / 2.0, "px"),
        lineHeight: "".concat(lineHeight.min + (lineHeight.max - lineHeight.min) / 2.0, "px")
      };
      styles["@media ".concat(l.get(false))] = {
        fontSize: "".concat(fontSize.max, "px"),
        lineHeight: "".concat(lineHeight.max, "px")
      };
    }
  } else {
    styles.lineHeight = "calc(".concat(props.$lineHeight, " * 1.07)");
    styles.fontSize = props.$fontSize;
    styles.marginTop = "calc(-".concat(props.$lineHeight, " * 0.07 + ").concat(props.marginTop || props.margin || '0px', ")");
    styles.marginBottom = "calc(-".concat(props.$lineHeight, " * 0.07 + ").concat(props.marginBottom || props.margin || '0px', ")");
  }
  return styles;
};
var useStyles = function useStyles(_ref) {
  var fontWeight = _ref.fontWeight,
    letterSpacing = _ref.letterSpacing,
    textCase = _ref.textCase,
    textTransform = _ref.textTransform,
    spacing = _ref.spacing,
    lineClamp = _ref.lineClamp,
    lineHeight = _ref.lineHeight,
    fontSize = _ref.fontSize,
    responsive = _ref.responsive,
    textUnderlineOffset = _ref.textUnderlineOffset;
  var styles = {
    fontWeight: fontWeight,
    letterSpacing: letterSpacing,
    textTransform: textTransform,
    textCase: textCase,
    textUnderlineOffset: textUnderlineOffset
  };
  if (lineClamp) {
    styles.display = '-webkit-box';
    styles.overflow = 'hidden';
    styles.textOverflow = 'ellipsis';
    styles.WebkitLineClamp = lineClamp;
    styles.WebkitBoxOrient = 'vertical';
  }
  var screensize = useScreenSize();
  if (responsive) {
    var _window2, _window2$supports;
    var responsiveFontSize = responsive.fontSize,
      responsiveLineHeight = responsive.lineHeight;
    if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.CSS) !== null && _window2 !== void 0 && (_window2$supports = _window2.supports) !== null && _window2$supports !== void 0 && _window2$supports.call(_window2, 'font-size', 'clamp(1px, 1vw, 1px)')) {
      var fontSlope = (responsiveFontSize.max - responsiveFontSize.min) / (MAX_WIDTH - MIN_WIDTH);
      var fontIntersection = -MIN_WIDTH * fontSlope + responsiveFontSize.min;
      styles.fontSize = "clamp(".concat(responsiveFontSize.min, "px, ").concat(fontIntersection, "px + ").concat(fontSlope * 100, "vw, ").concat(responsiveFontSize.max, "px)");
      var lineSlope = (responsiveLineHeight.max - responsiveLineHeight.min) / (MAX_WIDTH - MIN_WIDTH);
      var lineIntersection = -MIN_WIDTH * lineSlope + responsiveLineHeight.min;
      styles.lineHeight = "clamp(".concat(responsiveLineHeight.min, "px, ").concat(lineIntersection, "px + ").concat(lineSlope * 100, "vw, ").concat(responsiveLineHeight.max, "px)");
    } else {
      styles.fontSize = "".concat(responsiveFontSize.min, "px");
      styles.lineHeight = "".concat(responsiveLineHeight.min, "px");
      if (screensize === 'm') {
        styles.fontSize = "".concat(responsiveFontSize.min + (responsiveFontSize.max - responsiveFontSize.min) / 2.0, "px");
        styles.lineHeight = "".concat(responsiveLineHeight.min + (responsiveLineHeight.max - responsiveLineHeight.min) / 2.0, "px");
      }
      if (screensize === 'l') {
        styles.fontSize = "".concat(responsiveFontSize.max, "px");
        styles.lineHeight = "".concat(responsiveLineHeight.max, "px");
      }
    }
  } else {
    styles.lineHeight = "calc(".concat(lineHeight, " * 1.07)");
    styles.fontSize = fontSize;
    styles.marginTop = "calc(-".concat(lineHeight, " * 0.07 + ").concat(spacing.marginTop || spacing.margin || '0px', ")");
    styles.marginBottom = "calc(-".concat(lineHeight, " * 0.07 + ").concat(spacing.marginBottom || spacing.margin || '0px', ")");
  }
  return {
    styles: styles
  };
};
var TypographyStyled = /*#__PURE__*/styled(withSpacing('p')).withConfig({
  displayName: "Typographystyled__TypographyStyled",
  componentId: "sc-1uoovui-0"
})(function (props) {
  return getStyles(props);
});

export { TypographyStyled, getStyles, useStyles };
//# sourceMappingURL=Typography.styled.js.map
